// ── useTicketUpdates.js ──────────────────────────────────────────────
// Detects whether any of the current user's tickets changed status
// since they last opened Settings → My Tickets. Powers the small red
// dot on the TopBar settings gear icon.

import { useState, useEffect, useCallback } from 'react';
import { collection, query, where, getDocs, doc, getDoc } from 'firebase/firestore';
import { db } from './firebase';

export function useTicketUpdates(user) {
  const [hasUpdate, setHasUpdate] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) { setHasUpdate(false); return; }
    try {
      const [ticketsSnap, userSnap] = await Promise.all([
        getDocs(query(collection(db, 'tickets'), where('userId', '==', user.uid))),
        getDoc(doc(db, 'users', user.uid)),
      ]);
      const lastSeen = userSnap.exists() ? userSnap.data().lastSeenTicketsAt : null;
      const lastSeenMs = lastSeen?.toDate ? lastSeen.toDate().getTime() : 0;
      const hasNew = ticketsSnap.docs.some(d => {
        const t = d.data();
        if (!t.updatedAt) return false;
        const updatedMs = t.updatedAt?.toDate ? t.updatedAt.toDate().getTime() : 0;
        return updatedMs > lastSeenMs;
      });
      setHasUpdate(hasNew);
    } catch (e) {
      console.error('useTicketUpdates error:', e);
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  // markSeen: optimistic local clear, called right after Settings writes lastSeenTicketsAt
  const markSeen = useCallback(() => setHasUpdate(false), []);

  return [hasUpdate, markSeen];
}
